import { User, UserList, UserNew, UserEdit } from '@/components/User';

export default {
  path: '/user/',
  component: User,
  meta: {
    text: 'ユーザー管理',
    level: 2,
  },

  children: [
    {
      path: '',
      redirect: 'list',
    },
    {
      path: 'list',
      component: UserList,
      meta: {
        text: '一覧',
      },
    },
    {
      path: 'new',
      component: UserNew,
      meta: {
        text: '新規登録',
      },
    },
    {
      path: 'edit/:id',
      component: UserEdit,
      meta: {
        text: '編集',
      },
    },
  ],
};
